import { useState } from 'react';
import PrivacyPolicyModal from '@/components/PrivacyPolicyModal';
import TermsModal from '@/components/TermsModal';
import AccessibilityModal from '@/components/AccessibilityModal';

const Footer = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isAccessibilityModalOpen, setIsAccessibilityModalOpen] = useState(false);

  return (
    <footer className="border-t border-border bg-background py-8 mt-32" role="contentinfo">
      <div className="max-w-[1280px] mx-auto px-4 md:px-16">
      <div className="flex flex-col lg:flex-row-reverse justify-between items-center gap-6">
        <nav className="flex flex-wrap gap-4 lg:gap-8 text-sm font-body font-normal justify-center" role="navigation" aria-label="Footer links">
            <button
              onClick={() => setIsPrivacyModalOpen(true)}
              className="text-muted-foreground hover:text-primary transition-colors underline underline-offset-4 min-h-[44px] px-2 py-2 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
              aria-label="View privacy policy"
            >
              Privacy Policy
            </button>
            <button 
              onClick={() => setIsTermsModalOpen(true)}
              className="text-muted-foreground hover:text-primary transition-colors underline underline-offset-4 min-h-[44px] px-2 py-2 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
              aria-label="View terms of service"
            >
              Terms of Service
            </button>
            <button 
              onClick={() => setIsAccessibilityModalOpen(true)}
              className="text-muted-foreground hover:text-primary transition-colors underline underline-offset-4 min-h-[44px] px-2 py-2 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
              aria-label="View accessibility statement"
            >
              Accessibility
          </button>
        </nav>
        <p className="text-muted-foreground text-sm font-body text-center lg:text-left whitespace-nowrap">
          © 2018-2025 Sink Bike Run
        </p>
      </div>
      </div>
      
      <PrivacyPolicyModal
        isOpen={isPrivacyModalOpen} 
        onClose={() => setIsPrivacyModalOpen(false)} 
      />
      <TermsModal 
        isOpen={isTermsModalOpen} 
        onClose={() => setIsTermsModalOpen(false)} 
      />
      <AccessibilityModal 
        isOpen={isAccessibilityModalOpen} 
        onClose={() => setIsAccessibilityModalOpen(false)} 
      />
    </footer>
  );
};

export default Footer;